var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"m24.826 0c-13.689 0-24.826 11.137-24.826 24.826 0 13.688 11.137 24.826 24.826 24.826 13.688 0 24.826-11.138 24.826-24.826 0-13.689-11.136-24.826-24.826-24.826zm6.174 25.7h-4.039v14.396h-5.985s0-7.866 0-14.396h-2.845v-5.088h2.845v-3.291c0-2.357 1.12-6.04 6.04-6.04l4.435.017v4.939s-2.695 0-3.219 0-1.269.262-1.269 1.386v2.99h4.56z","data-original":"#000000","className":"active-path","data-old_color":"#000000","fill":"#FFFFFF"})))));
}

FacebookInline.defaultProps = {"id":"Capa_1","enableBackground":"new 0 0 49.652 49.652","height":"512px","viewBox":"0 0 49.652 49.652","width":"512px","className":""};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
